<script>
export default {
  name: 'ReportsFiltersInboxes',
  props: {
    enableCsatFilter: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['inboxFilterSelection'],
  data() {
    return {
      selectedOption: null,
      options: [],
    };
  },
  async mounted() {
    await this.$store.dispatch('inboxes/get');
    // 0. 直接从 store 获取数据
    const inboxes = this.$store.getters['inboxes/getInboxes'] ?? [];

    if (this.enableCsatFilter) {
      // 1. 过滤数据作为选项
      // "csat_report_filter_enable": true  // 允许出现在筛选项
      this.options = inboxes.filter(el => el.csat_report_filter_enable);

      if (inboxes.length > 0) {
        // 2. 设置默认选项
        // "csat_report_filter_default": true  // 筛选项默认选中
        this.selectedOption = inboxes.filter(
          inbox => inbox.csat_report_filter_default
        );
        // 3. 触发选择事件
        this.handleInput();
      }
    } else {
      this.options = inboxes;
    }
  },
  methods: {
    handleInput() {
      this.$emit('inboxFilterSelection', this.selectedOption);
    },
  },
};
</script>

<template>
  <div class="multiselect-wrap--small">
    <multiselect
      multiple
      :close-on-select="false"
      :clear-on-select="false"
      hide-selected
      v-model="selectedOption"
      class="no-margin"
      :placeholder="$t('INBOX_REPORTS.FILTER_DROPDOWN_LABEL')"
      label="name"
      track-by="id"
      :options="options"
      :option-height="24"
      :show-labels="false"
      @update:model-value="handleInput"
    />
  </div>
</template>
